var React = require('react');

function Cube (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1","data-name":"Path 1","d":"M6433.787,6947.194v-14.176l11.262,6.237v14.177Zm13.658-7.938,11.262-6.237v14.176l-11.262,6.238Zm-5.151-4.265-7.049-3.9,11-5.036,11,5.036-7.049,3.9-3.953,2.189Zm-8.544-5.854-1.66.76-.7.32v18.39l5.573,3.087,8.7,4.82h0l.58.321.581-.321h0l8.7-4.82,5.574-3.087v-18.39l-.7-.32-1.66-.76-12.5-5.72Z","transform":"translate(-6431.391 -6923.417)","fill":"#fff"}));
}

Cube.defaultProps = {"viewBox":"0 0 29.712 33.418"};

module.exports = Cube;

Cube.default = Cube;
